import { AllCheckListModelResponseModel, CheckListResponseModel, CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { CheckListModelService } from './checklist-model.service';
// import { CertificatesRequest } from './dto/checklist-model.request';
import { CheckListModelDTO } from './dto/checklist-model.dto';

@ApiTags('checklistmodel')
@Controller('checklistmodel')
export class CheckListModelController {
  constructor(
    private checklistmodelService: CheckListModelService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }
  @Post('/createChecklist')
  async createCheklist(@Body() checklistmodelDto: CheckListModelDTO, isUpdate: boolean = false): Promise<CheckListResponseModel> {
    try {
      return await this.checklistmodelService.createChecklist(checklistmodelDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CheckListResponseModel, error);
    }
  }

  @Post('/getAllChecklists')
  async getAllChecklists(): Promise<AllCheckListModelResponseModel> {
    try {
      return await this.checklistmodelService.getAllChecklists();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllCheckListModelResponseModel, error);
    }
  }


  @Post('/getAllCheckListDropDown')
  async getAllCheckListDropDown(): Promise<CommonResponse> {
    try {
      return await this.checklistmodelService.getAllCheckListDropDown();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
  }

  @Post('/deleteCheckList')
  async deleteCheckList(@Body() checklistmodelDto: CheckListModelDTO, isUpdate: boolean = false): Promise<CheckListResponseModel> {
    try {
      return await this.checklistmodelService.deleteCheckList(checklistmodelDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CheckListResponseModel, error);
    }
  }
}
